/**
 * created by tian ruo jun
 组图页面
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Tooltip, Button, Modal, message, Tabs, Input, Radio, InputNumber, Form, Divider, Icon} from "antd";
import noView from "../../image/noView.png";
import ImagesLocally from "../uploadAtlas/imagesLocally/ImagesLocally";
import {uuid,permissionCheck} from "../../../../utils";
import MosaicReleaseImage from "../imageRelease/components/mosaicReleaseComponent/MosaicReleaseImage";
import ImgUpload from "../../../sysManagement/paramConfiguration/configEditModal/components/ConfigValue/ImgUpload/ImgUpload";
import {Scrollbars} from "react-custom-scrollbars";
import BaseComponent from "../../../../base/BaseComponent";
import ActivitiModal from "../../../editor/components/activitiAndBtn/ActivitiModal";
import {rmtMessage} from "../../components/mess";
import CurrencyResourceDialog from "../../../resource/view/dialog/CurrencyResourceDialog";
import SyncModal from "../../../components/syncModal/syncModal";

const {TabPane} = Tabs;
const FormItem = Form.Item;
const {TextArea} = Input;
let setting = {
  titleMaxlength: 255,
  summaryMaxlength: 1000,
};

export default class Photos extends BaseComponent {
    static defaultProps = {
        isShowPhotosBtn: true
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            selectedTab: "1",
            photosVisible: false, // 组图弹窗
            uploadVisible: false, // 上传弹窗
            atlasList: [], // 组图页面上传的数据
            uploadFileList: [], // 上传页面上传的数据
            formData: {
                title: '',
                titlePic: '',
                atlasList: [],
                variableFields: {}
            }, // 表单数据
            focusKey: [], // 获取焦点的图片
            showNewPhotos: true,
            zykFileList: [],
            activitiConfName: this.sysConfigGetValueByKey("editor.activiti.conf.name.wzlc", "activitiTreeRoot-xlc-wzlc"),
            id: "",
            modalKey:uuid(), //上传图片弹窗key
            newDate: Date.now(),
            newPicType:['jpg','jpeg', 'gif', 'png', 'bmp'],
            isDelete: false,
        }
    }


    componentWillMount() {
        this.getSysConfigGetValueByKey();
        this.initActivitiConfig({});
        this.getColumnInfo();
    }

    componentDidMount() {
    }

    // 获取配置项
    getSysConfigGetValueByKey = () => {
        setting.summaryMaxlength = this.sysConfigGetValueByKey("photosSummary.maxlength", "1000")*1;
    };

    /**设置流程配置*/
    initActivitiConfig(data) {
        let id = (this.state.id && this.state.id.length > 1 && this.state.id != 'null' && this.state.id != 'undefined') ? this.state.id : '';
        let that = this;
        let account = (window.currentUser && window.currentUser.account) ? window.currentUser.account : "";
        let userId = (window.currentUser && window.currentUser.id) ? window.currentUser.id : "";
        let noPublishConfig = this.sysConfigGetValueByKey("materialCenter.publishBtn.exclude", "已发布");
        let mustNotShowPublishBtn1 = (data.statusName && noPublishConfig.indexOf(data.statusName)>-1)?false :true
        let mustNotShowPublishBtn2 = that.urlParams && that.urlParams.mustNotShowPublishBtn ? that.urlParams.mustNotShowPublishBtn : false;
        // 重置流程条件start
        let againFlag = false;
        let reloadStatus = this.sysConfigGetValueByKey("webNews.activiti.reload.status", "");
        if (data.statusName && reloadStatus.indexOf(data.statusName) > -1) { // 弃用状态重启审核流
            againFlag = true;
        }
        let activitiConf = this.state.activitiConfName ? {type: this.state.activitiConfName} : null;
        // 如果草稿稿件可以被创建人之外的人看到，则需要手动控制审核流不要重启
        if (data && data.statusName === "草稿" && data.creator !== userId) {
            // 当稿件状态为草稿时，审核流会自动重启，此时将activitiConf置空则审核流不重启
            activitiConf = null
        }
        // 重置流程条件end
        this.state.activityOption = {
            id: id,//流程id
            activitiConf,//流程conf
            pojoName: 'webNews',//数据表name
            userAccount: account,//当前用户account
            showBtnFlag: true,//是否显示流程按钮
            againFlag,//重置流程的判断条件
            showAfterFuns: {
                /**
                 * 是否是投稿稿件来源（弃用，返回写稿人按钮显隐判定）
                 */
                fromContribute: (item, call) => {
                    if(that.state.operateType && that.state.operateType === "contribute") {
                        call({code: 1});
                    } else {
                        call({code: 0, log: "非投稿稿件！"});
                    }
                },
                /**
                 * 弃用
                 */
                abandon: (item, call) => {
                    if(id) {
                        call({code: 1});
                    } else {
                        call({code: 0, log: "新增稿件没有弃用权限！"});
                    }
                },
            },//流程按钮加载前置js
            getTextRequisite: false,//备注是否必填
            otherJs: {
                setSourceUser: (activiti, buttonConf, call) => {
                    try {
                        activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                            id: this.webStory.creator,
                            name: this.webStory.creatorName
                        }];
                        call({code: 1, log: "查询到返回者为：" + this.webStory.creator});
                    } catch (e) {
                        message.error(e);
                        throw e;
                    }
                },
                /**
                 * 撤稿前置js
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                callActRevert: function (activiti, buttonConf, call) {
                    activiti.terminate.call(activiti, function (res) {
                        if (res == true) {
                            activiti.options.statusNameTemp = "草稿";
                            activiti.endFunction(activiti, function (res) {
                                if(res){
                                    message.warning("流程已撤回，稿件变为草稿状态", 1, ()=>{
                                        activiti.submitOK();
                                    });
                                }
                            })
                        }
                    });
                },
                 /**
                 * 修改完成后直接提交给返回的人 不经过中间审核
                 * @param activiti
                 * @param buttonConf
                 * @param call
                 */
                 callAgent: function (activiti, buttonConf, call) {
                    let uuid = activiti.options.uuid;
                    that.request({
                        url: "/cm-sites-sys/process/getProcessHistory",
                        method: "post",
                        body: {bizKey: uuid},
                        callBack: (data) => {
                            let historyList = data;
                            if (historyList && historyList.length > 1 && historyList[0].candidateInfo && historyList[0].candidateInfo.length) {
                                let callBackHistory = historyList[0];
                                activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [{
                                    id: callBackHistory.operatorUserInfo.userId,
                                    name: callBackHistory.operatorName,
                                    deptId:  callBackHistory.operatorUserInfo.deptId,
                                }];
                                call({code: 1, log: "查询到返回者为：" + callBackHistory.candidateNames[0]});
                            } else {
                                call({code: -1, msg: "未查询到返回者！"})
                            }
                        },
                        errorCallBack: () => {
                            message.error("未查询到返回者！");
                            window.loading.hide();
                        },
                    });
                },
            },//流程按钮点击事件前置js
            saveFunction: that.onOk,//稿件保存方法
            publish: that.publish,
            saveStatusNameFunction: that.updateStatusName,//稿件改流程状态方法
            onSubmitOK: function (activiti) {
                that.onCancel()
            },//流程事件运行完毕的回调
            successCall: () => {
            },//流程加载完的回调
            readyCall: () => {
            },//流程初始化完的回调
            onlyShowBtn: true,//是否只返回流程按钮
            title: '',//流程弹窗title
            visible: false,//流程弹窗是否展示
            btnLoadOver: (btns) => {
                this.activitiBtns = btns;
                this.setState({});
            },
            showBtnIcon: false,
            btnType: "primary",
            chooseFilterObject: function (users, call) {
                if (!users || users.length < 1) {
                    call && call(users);
                    return false
                }
                let mediaInfo = {
                    contentId: that.props.dynamicParams.contentId,
                    mediaId: that.props.dynamicParams.mediaId
                };
                if(!mediaInfo) {
                    message.warning("过滤媒体权限失败，请先选择主栏目");
                    window.loading.hide();
                    return false
                }
                let receivers = users.map(item=>({
                    deptId: item.deptData[0]._id,
                    userId: item._id,
                }));
                that.request({
                    url: "/cm-sites-pms/contribute/filterUser",
                    method: "post",
                    contentType: "json",
                    body: {
                        mediaInfo,
                        receivers
                    },
                    callBack: (list) => {
                        let newUsers = [];
                        if(list&&list.length) {
                            newUsers=list
                            call && call(newUsers)
                        } else {
                            message.warning("未查到拥有媒体权限的待办用户");
                            window.loading.hide();
                        }
                    },
                    errorCallBack: () => {
                        this.error("过滤媒体权限失败,请稍后重试");
                        window.loading.hide();
                    },
                });
            },
            checkForm: that.checkFrom,
            showRemarks: (remarks) => {
                if(remarks && remarks.length) {
                    this.setState({showRemarks:true,remarks})
                }
            },//备注回显
            // 控制前端发布按钮的显隐
            mustNotShowPublishBtn: (mustNotShowPublishBtn1 || mustNotShowPublishBtn2) ? true : false,
        };
        this.setState({});
    }

    getColumnInfo = (call) => {
        let dynamicParams = this.props.dynamicParams || {},
            contentId = dynamicParams.contentId,
            mediaId = dynamicParams.mediaId,
            treeId = dynamicParams.treeId;
        if (contentId && mediaId && treeId) {
            this.request({
                url: "/cm-sites-pms/website/getColumnInfo",
                body: {
                    contentId,
                    mediaId,
                    treeId
                }, callBack: (res) => {
                    let contentName = "";
                    let mediaName = "";
                    let treeName = "";
                    if (res) {
                        contentName = res.contentName;
                        mediaName = res.mediaName;
                        treeName = res.treeName;
                    }
                    if(!contentName || !mediaName || !treeName) {
                        message.warning("获取媒体信息失败，请稍后重试。");
                        return false
                    }
                    this.state.contentName = contentName;
                    this.state.mediaName = mediaName;
                    this.state.treeName = treeName;
                    call&&call();
                },errorCallBack: (e) => {
                    message.warning("获取媒体信息失败，请稍后重试。")
                }
            });
        }
    };

    // 新增组图按钮
    render() {
        return (
            <>
                {this.props.isShowPhotosBtn ?
                    <Button style={{marginLeft: 16}} onClick={() => {
                        this.setState({photosVisible: true})
                    }}
                    >
                        {this.props.btnName || "新建组图"}
                    </Button> : null}
                {this.renderPhotos()}
                {this.renderUpload()}
                <CurrencyResourceDialog
                    onCallBackOk={(checkedData,call)=>{
                        this.checkFile(checkedData,(newFiles)=>{
                            this.state.showNewPhotos =true;
                            let zykFileList = newFiles.map(item=>{
                                let newItem = {
                                    ...item,
                                    url:item.path,
                                    uid:item.id,
                                    title:item.name
                                };
                                return newItem ;
                            })
                            call(true)
                            this.state.zykFileList = zykFileList;
                            this.state.atlasList = [...this.state.atlasList,...this.state.uploadFileList, ...this.state.zykFileList];

                            this.setState({photosVisible:true, showNewPhotos: false,zykFileList: []});
                        },call)

                    }}
                    ref={resourceDialog=>this.resourceDialog = resourceDialog} />
            </>
        )
    }

    checkFile = (files,checkCall,closeCall) => {
        let newPicTypeList = [...this.state.newPicType, ...this.state.newPicType.toUpperCase()]
        if(!files?.length) {
            message.destroy();
            message.warning("请先选择一个资源");
            // closeCall&&closeCall(true);
            return false
        }
        let newFiles = files;
        let checkResult = files.every(file=>newPicTypeList.indexOf(file.suffix)>-1);
        if(!checkResult) {
            message.destroy();
            message.error(`暂不支持该文件类型！`);
            return false
        }
        checkCall&&checkCall(newFiles)
    }


    // 组图弹窗
    renderPhotos = () => {
        const {formData} = this.state;
        return (
            <Modal
                centered={true}
                title="组图发布"
                visible={this.state.photosVisible}
                maskClosable={false}
                onCancel={() => {
                    this.onCancel()
                }}
                keyboard={false}
                bodyStyle={{height: 650}}
                width={1200}
                destroyOnClose={true}
                wrapClassName='renderPhotos'
                okText="确定"
                footer={
                    this.renderFooter()
                }
            >
                <Scrollbars style={{height: 585}}>
                    {
                        !this.state.showNewPhotos ?
                            this.renderEditPhotos()
                            : this.renderNewPhotos()
                    }
                    <style>
                        {`
                          .renderPhotos .ant-modal-body {
                            padding:25px 30px 40px 40px
                          }
                          .renderPhotos .ant-modal-footer button + button {
                            margin-left: 12px !important;
                          }
                    `}
                    </style>
                </Scrollbars>
            </Modal>
        )
    };

    renderFooter = () => {
        return (
            !this.state.showNewPhotos && !this.state.isDelete ?
                (<div>
                    <ActivitiModal
                        {
                            ...this.state.activityOption
                        }
                    />
                    {this.renderOtherBtn()}
                    <SyncModal ref={ref=>this.syncModal=ref}/>
                </div>)
                :
                (<div>
                    <Button onClick={() => {
                        this.onCancel()
                    }}>取消</Button>
                </div>)
        )
    };

    renderOtherBtn = () => {
        const {formData} = this.state;
        return (
            <>
                {
                    (() => {
                        if (this.activitiBtns && (this.activitiBtns.length > 0)) {
                            let configBtns = this.sysConfigGetValueByKey("web.editor.saveBtn.mutex.activiti.btn", "撤回").split(",");
                            let result = true;
                            this.activitiBtns && this.activitiBtns.map(item => {
                                if (configBtns.indexOf(item.name) > -1) {
                                    result = false;
                                }
                            });
                            return result;
                        }
                        return false;
                    })() ? <Button style={{margin: "0 12px"}} onClick={() => {
                        this.onOk(null, null)
                    }} type="primary">暂存</Button> : null
                }
                {
                    this.state.showRemarks?(
                        <Button
                            type={"primary"}
                            onClick={this.showRemarksCall}
                            style={{margin: "0 12px"}}>查看备注</Button>
                    ):null
                }
                {/*{*/}
                {/*    formData.statusName && formData.statusName.indexOf('发布') > -1 ?*/}
                {/*        null :*/}
                {/*        <Button style={{margin: "0 12px"}} onClick={() => {*/}
                {/*            this.onOk('publish')*/}
                {/*        }} type="primary">发布</Button>*/}
                {/*}*/}
                <Button style={{margin: "0 12px"}} onClick={() => {
                    this.onCancel()
                }}>取消</Button>
            </>
        )
    };

    // 查看备注
    showRemarksCall = () =>{
        let that = this;
        that.syncModal.confirm({
            title: "备注",
            width: 400,
            content: <TextArea value={that.state.remarks} placeholder={"请输入"} maxLength={200} rows={2}
                               style={{width: 350, height: 64, fontSize: 14}}
                               ref={(remarksTextArea) => that.remarksTextArea = remarksTextArea}/>,
            okText: "确定",
            cancelText: "取消",
            onOk: () => {
                that.syncModal.destroy();
            },
            footer: <Button onClick={()=>{that.syncModal.destroy();}}>关闭</Button>,
            onCancel: () => {
                that.syncModal.destroy();
            }
        });
    };

    // 关闭弹窗
    onCancel = () => {
        this.setState({photosVisible: false});
        if (typeof this.props.onOkCall === 'function') {
            this.props.onOkCall()
        }
        if(this.callback && typeof this.callback === 'function') {
            this.callback();
        }
    };

    callback;

    showEditModal = (data,callback) => {
        if(!data?.id) {
            message.error('组图加载失败！');
            return false
        }
        this.getById(data?.id,(record)=>{
            if(record.variableFields?.recycle&&(record.variableFields.recycle ==="1" || record.variableFields.recycle ==="2" )) {
                this.setState({isDelete:true})
            }
            let atlasList=record.atlasList;
            atlasList.forEach((item,index)=>{
                item.uid=index;
            });
            this.callback=callback;
            this.getColumnInfo(()=>{
                this.setState({
                    showNewPhotos: false,
                    atlasList: record.atlasList,
                    formData: record,
                    photosVisible: true,
                    id: record.id,
                }, () => {
                    this.initActivitiConfig(record)
                })
            });
        })
    };

    getById = (id,call) => {
        this.request({
            url: "/cm-sites-pms/website/news/getById",
            body: {webNewsId:id},
            callBack: function (res) {
                if (res) {
                    call(res)
                } else {
                    message.error('该组图已被删除！');
					this.setState({isDelete:true});
                }
            },
            errorCallBack: function (res) {
                message.error('组图加载失败！');
				this.setState({isDelete:true});
            }
        })
    }

    // 编辑组图
    renderEditPhotos = () => {
        let {atlasList, formData} = this.state;
        let disable = (formData && formData.statusName && formData.statusName.indexOf('发布123') > -1) ? true : false;
        return (
            <div>
                <Button disabled={disable} type="primary" style={{marginBottom: 10,marginRight:20}} onClick={() => {
                    this.setState({uploadVisible: true})
                }}>本地上传</Button>
                {permissionCheck('right_to_use_zyk')?  <Button disabled={disable} type="primary" style={{marginBottom: 10}} onClick={() => {
                   this.resourceDialog.show()
               }}>资源库上传</Button>:null}

                {/*{this.renderUploadBtn()}*/}
                <div style={{display: 'flex', flexWrap: 'wrap'}}>
                    {
                        atlasList && atlasList.length ? (
                            atlasList.map((item, index) => {
                                return (
                                    <MosaicReleaseImage
                                        key={index}
                                        keyNum={index}
                                        disable={disable}
                                        file={item}
                                        onDeleteCall={(uid) => {
                                            atlasList&&atlasList.length&&atlasList.forEach((item,i)=>{
                                               if(item.uid ===uid && index === i){
                                                   atlasList.splice(index,1)
                                               }
                                            })
                                            let newAtlasList = atlasList;
                                            this.setState({atlasList: newAtlasList})
                                        }}
                                        onEditTitlePicCall={(url) => {
                                            formData.titlePic = url;
                                            this.setState({})
                                        }}
                                        onEditDescriptionCall={(file, uid) => {
                                            let index = this.state.atlasList.findIndex(item => item.uid == uid);

                                            this.state.atlasList[index] = file;
                                            this.setState({});
                                            // console.log(this.state.atlasList,"111",index)
                                        }}
                                        onFocusCall={(file, uid) => {
                                            this.setState({focusKey: [uid]})
                                        }}
                                        focusKey={this.state.focusKey}
                                    />
                                )
                            })
                        ) : null
                    }
                </div>
                <Divider/>
                <Form labelCol={{span: 2}} wrapperCol={{
                    span: 21,
                    // offset: 1输入框左外边距
                }}
                      onSubmit={(e) => { // 启动了表单的回车确认功能
                      }}>
                    <FormItem
                        label={'标题'}
                        required={true}
                    >
                        <Input
                            placeholder={`请输入标题（不超过${setting.titleMaxlength}字）`}
                            maxLength={setting.titleMaxlength}
                            disabled={disable}
                            onChange={(e) => {
                                this.onFromChange({title: e.target.value})
                            }}
                            value={formData.title}
                        />
                    </FormItem>
                    <FormItem
                        label={'预览图'}
                        required={false}
                    >
                        <ImgUpload
                            disabled={disable}
                            onChange={titlePic => this.onFromChange({titlePic})}
                            value={formData.titlePic}
                        />
                    </FormItem>
                    <FormItem
                        label={'内容摘要'}
                        required={false}
                    >
                        <TextArea
                            placeholder={`请输入内容摘要（不超过${setting.summaryMaxlength}字）`}
                            maxLength={setting.summaryMaxlength}
                            disabled={disable}
                            style={{resize: 'none', background: '#eef2fb'}}
                            value={formData.variableFields.summary}
                            onChange={(e) => {
                                this.onVariableFieldsChange({summary: e.target.value})
                            }}
                            autoSize={{minRows: 3, maxRows: 5}}
                        />
                    </FormItem>
                    <div className={'rmt-form-item'}
                         style={{display: 'flex', lineHeight: '32px', alignItems: 'flex-start', paddingRight: 32}}>
                        <div className={'photosLabel'} style={{width: 93.3, textAlign: 'right'}}>标签</div>
                        <style>
                            {
                                `
                                .rmt-form-item > .photosLabel::after {
                                    content: ':';
                                    position: relative;
                                    top: -0.5px;
                                    margin: 0 8px 0 2px;
                                    }
                                `
                            }
                        </style>
                        <div style={{flex: 22}}>
                            <div style={{display: 'inline-block'}}>
                                <Input style={{width: 251, display: 'inline-block', flex: 'unset'}}
                                       onChange={(e) => {
                                           this.onFromChange({labelInputVal: e.target.value})
                                       }}
                                       value={formData.labelInputVal}
                                       disabled={disable}
                                       maxLength={50}
                                />
                                <Button icon="plus"
                                        style={{
                                            width: 32,
                                            lineHeight: '17px',
                                            margin: '0 10px',
                                            color: '#595a5b',
                                            display: 'inline-block',
                                        }}
                                        onClick={() => {
                                            if (!formData.variableFields.label) {
                                                formData.variableFields.label = []
                                            }
                                            if(formData.variableFields.label.includes(formData.labelInputVal)) {
                                                message.destroy();
                                                message.error("请勿输入相同的标签");
                                            } else {
                                                if (formData.labelInputVal) {
                                                    let newLabelArr = [...formData.variableFields.label, formData.labelInputVal];
                                                    this.onVariableFieldsChange({label: newLabelArr});
                                                    formData.labelInputVal = ""
                                                } else {
                                                    // message.destroy();
                                                    // message.error("标签内容为空，请输入")
                                                }
                                            }
                                        }}
                                />
                                {formData.variableFields && formData.variableFields.label && formData.variableFields.label.length > 0 ?
                                    formData.variableFields.label.map(item => (
                                        <div key={item}
                                             style={{
                                                 display: 'inline-block',
                                                 padding: '0 8px',
                                                 width: 'auto',
                                                 margin: '0px 8px 0px 0px',
                                                 lineHeight: '32px',
                                                 border: '1px solid #dcdcdc',
                                                 borderRadius: '5px',
                                             }}>
                                            {item}
                                            {
                                                disable ? null :
                                                    <Icon type="close"
                                                          onClick={() => {
                                                              formData.variableFields.label = formData.variableFields.label.filter(label => label !== item);
                                                              // console.log('information.label     ', formData.variableFields.label);
                                                              this.setState({});
                                                          }}
                                                          style={{
                                                              marginLeft: 8,
                                                              fontSize: 12,
                                                              cursor: 'pointer',
                                                              color: '#afafaf',
                                                          }}/>
                                            }
                                        </div>
                                    ))
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        )
    };

    // 新增组图
    renderNewPhotos = () => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <img style={{width: 187}} src={noView}/>
                <div>
                    <Button onClick={() => {
                        this.setState({uploadVisible: true})
                    }} style={{cursor: "pointer", border: '1px solid ' + this.themeBgColor,marginRight:20}}>
                        本地上传
                    </Button>
                    {
                        permissionCheck('right_to_use_zyk')? <Button onClick={() => {
                            this.resourceDialog.show()
                        }} style={{cursor: "pointer", border: '1px solid ' + this.themeBgColor}}>
                            资源库上传
                        </Button>:null
                    }

                </div>

            </div>
        )
    };
    // 上传图片弹窗
    renderUpload = () => {
        return (
            <Modal
                centered={true}
                title="本地上传"
                visible={this.state.uploadVisible}
                key = {this.state.modalKey}
                onOk={() => {
                    let atlasList = [...this.state.atlasList,...this.state.uploadFileList, ...this.state.zykFileList];
                    this.state.atlasList = atlasList.map(item=>{
                        let newItem = {
                            ...item,
                            title:item.name || item.title
                        };
                        return newItem ;
                    })
                    // this.state.atlasList = atlasList.filter((item)=>{
                    //     return this.state.newPicType.indexOf(item.suffix) !== -1 || this.state.newPicType.indexOf(item.ext) !== -1})
                    // if(atlasList.length > this.state.atlasList.length ){
                    //     message.error(`图片格式不正确，只能上传以下图片格式：${this.state.newPicType.join("，")}`);
                    // }
                    if (this.state.atlasList.length == 0) {
                        rmtMessage.error('请先选择一张图片！');
                        return false;
                    }
                    this.setState({uploadVisible: false, showNewPhotos: false,modalKey:uuid(),uploadFileList:[],zykFileList:[]})

                }}
                onCancel={() => {
                    this.setState({uploadVisible: false})
                }}
                maskClosable={false}
                width={800}
                wrapClassName='renderUpload'
            >
                <div className="interval">
                    {/*<Tabs onChange={this.nativeBank}>*/}
                    {/*    <TabPane tab="本地上传" key="1">*/}
                            <div style={{padding: 24}}>
                                <Tooltip placement="right"
                                         title={this.state.newPicType.join("，") }>
                                    <span style={{color: '#F56C6C'}}>仅支持{this.state.newPicType.join("，")}格式图片</span>
                                </Tooltip>
                                <ImagesLocally onChange={(uploadFileList) => {
                                    this.setState({uploadFileList})
                                }} accept={this.state.newPicType}/>
                            </div>
                        {/*</TabPane>*/}
                        {/*<TabPane tab="图片库" key="2">*/}
                        {/*    <div style={{padding: 24}}>*/}
                        {/*        <ImagesGallery onChange={(zykFileList) => {*/}
                        {/*            this.setState({zykFileList})*/}
                        {/*        }}/>*/}
                        {/*    </div>*/}
                        {/*</TabPane>*/}
                    {/*</Tabs>*/}
                    <style>
                        {`
                         .renderUpload .interval .ant-tabs-bar{padding: 0px 32px;}
                         .renderUpload .interval .ant-tabs-tab {
                               font-size: 16px;
                               font-family: Microsoft YaHei;
                               font-weight: 400;
                               line-height: 22px;
                               color: #0050B3;
                               padding: 12px 0;
                          }
                          .renderUpload .ant-modal-body {
                            padding:10px 0 
                          }
                    `}
                    </style>
                </div>

            </Modal>
        )
    };

    nativeBank = (activeKey) => {
        this.setState({
            selectedTab: activeKey,
        })
    };

    // 表单校验
    checkFrom = (activiti, call) => {
        let {atlasList, formData} = this.state;
        let titlePic = formData.titlePic;
        let title = formData.title;
        if (!(atlasList && atlasList.length)) {
            message.destroy()
            message.warning("请先上传图片");
            window.loading.hide();
            return false
        }
        if (!(title && title.length)) {
            message.destroy();
            message.warning("请先填写标题");
            window.loading.hide();
            return false
        }
        let newAtlasList = atlasList.map((item,index) => ({
            describe: item.describe,
            title: item.title,
            url: item.url || item.path,
            uid:item.uid||index
        }));
        let body = {
            ...formData,
            atlasList: newAtlasList,
            ...this.props.dynamicParams,
            contentName: this.state.contentName,
            mediaName: this.state.mediaName,
            treeName: this.state.treeName,
            newdate: this.state.newDate,
        };
        if (!this.state.id) {
            // 新增稿件添加创建人
            let currentUser = window.currentUser ? window.currentUser : {};
            body = {
                ...body,
                "creator": currentUser.id,
                "creatorName": currentUser.name,
            };
        } else {
            body = {
                ...body,
                "creator": formData.creator,
                "creatorName": formData.creatorName,
            };
        }
        call&&call();
        return body
    };

    // 组图确认（发布）
    onOk = (activiti, call) => {
        let body = this.checkFrom();
        if (!body) {
            call && call(false);
            return false
        };
        this.save(activiti, call, body)
    };

    publishData={};

    // 暂存
    save = (activiti, call, params) => {
        let that = this;
        let url = '/cm-sites-pms/website/news/save';
        // 获取发布等状态
        let statusNameTemp = activiti && activiti.options && activiti.options.statusNameTemp || "";
        let autoSaveStatsConfName = that.sysConfigGetValueByKey("webNew.activiti.autoSave.states", "发布,已发布,修改完成并提交");
        let autoSaveStats = statusNameTemp && autoSaveStatsConfName.indexOf(statusNameTemp)>-1;
        if(autoSaveStats) {
            url = '/cm-sites-pms/website/news/autoSave';
        }
        this.request({
            url,
            method: 'POST',
            body: params,
            contentType: 'json',
            callBack: function (res, status, allData) {
                if (res) {
                    that.publishData=res;
                    // 获取发布状态
                    let activitiConfName = that.sysConfigGetValueByKey("editor.activiti.publish.states", "发布,已发布");
                    if (statusNameTemp && activitiConfName.indexOf(statusNameTemp) > -1) {
                        that.state.id = res.id;
                        call && call(res)
                        // that.publish(activiti, (publishBack) => {
                        //     if (publishBack) {
                        //         call && call(res)
                        //     } else {
                        //         call && call(false);
                        //     }
                        // }, res)
                    } else {
                        call && call(res);
                        that.state.id = res.id;
                        if (!activiti) {//点击了暂存按钮
                            message.success('保存成功！', 0.5, () => {
                                that.onCancel()
                            });
                        }
                    }
                    that.updateProcessAndData(res)
                } else {
                    message.error('保存失败！');
                    call && call(false);
                }
            },
            errorCallBack: function (e) {
                call && call(false);
                message.error('保存失败！');
            }
        });
    };

    // 更新流程稿件
    updateProcessAndData = (body) => {
        this.request({
            url: "/cm-sites-sys/process/updateProcessAndData",
            method: "post",
            contentType: "json",
            body: {
                title: body?.title,
                bizKey: body?.id,
                data: body,
            },
            callBack: (res)=>{

            }
        })
    };

    publish = (statusName, activiti, call) => {
        if(this.publishData && this.publishData.id) {
            let url = '/cm-sites-pms/website/news/publish';
            this.request({
                url,
                method: 'POST',
                body: this.publishData,
                contentType: 'json',
                callBack: () => {
                    call&&call({status: true, msg: "流程推进后发布成功。"});
                },
                errorCallBack: function (e) {
                    call&&call({status: false, msg: "流程推进后发布失败。"});
                }
            });
        } else {
            message.warn("发布失败！稿件id丢失")
        }

    };

    /**
     * 稿件修改状态
     */
    updateStatusName = (statusName, activiti, call) => {
        let id = (this.state.id && this.state.id != '0') ? this.state.id : '';
        let params = {
            "webNewsId": id,
            "statusName": statusName,
        };
        this.request({
            url: '/cm-sites-pms/website/news/saveStatusName',
            method: 'POST',
            body: params,
            callBack: function (res) {
                if (res) {
                    call && call({status: true, msg: "流程推进后状态修改成功。"});
                } else {
                    call && call({status: false, msg: "流程推进后状态修改失败。"});
                }
            },
            errorCallBack: function (res) {
                call && call({status: false, msg: "流程推进后状态修改失败。"});
            }
        });
    };

    // 发布
    // publish = (params) => {
    //     let that = this;
    //     this.request({
    //         url: '/cm-sites-pms/website/news/publish',
    //         method: 'POST',
    //         body: params,
    //         contentType: 'json',
    //         callBack: function (res, status, allData) {
    //             message.info(allData.message ? allData.message : '发布成功！');
    //             // if (status === 200) {
    //             //     if (allData.message) {
    //             //         message.error('同步站群失败！');
    //             //     } else {
    //             //         message.success('发布成功！');
    //             //     }
    //             // } else {
    //             //     message.error('发布失败！');
    //             // }
    //            that.onCancel()
    //         },
    //         errorCallBack: function (e) {
    //             message.error('发布失败！');
    //         }
    //     });
    // };
    // 上传前校验
    beforeUpload = file => {
        // const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
        // if (!isJpgOrPng) {
        //     message.error("You can only upload JPG/PNG file!");
        // }
        // const isLt2M = file.size / 1024 / 1024 < 2;
        // if (!isLt2M) {
        //     message.error("Image must smaller than 2MB!");
        // }
        // if(file.name){
        //     var fileCheckRegex=/[0-9]{8}-.*?-.*?-.*/;
        //     if(!fileCheckRegex.test(file.name)){
        //         message.error( "文件名称必须符合《yyyymmdd-活动名称-拍摄者-资源说明》格式",
        //             window.top.sysConfig.getValueByKey("showtime",3),
        //         );
        //         return  false;
        //     }
        // }
        // return isJpgOrPng && isLt2M;
        return true;
    };
    // 上传
    onUploadChange = (info) => {
        info.fileList = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if (info.file.response && info.file.response.data) {
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.path;
                item.name = info.file.response && info.file.response.name;
                item.type = "picture";
                item.isChunk = true;
                item.status = info.file.status;
            }
            return item;
        });
        this.setState({
            atlasList: info.fileList
        }, () => {
            console.log('this.state.atlasList==============', this.state.atlasList)
        })
    };

    // 表单
    onFromChange(data) {
        this.state.formData = {
            ...this.state.formData,
            ...data
        };
        this.setState({});
    }

    onVariableFieldsChange(data) {
        this.state.formData.variableFields = {
            ...this.state.formData.variableFields,
            ...data
        }
        this.setState({})
    }

}